export default __webpack_public_path__ + "static/media/678ca20b81455c531377e9c3c785576a1582225783870.1fbefda2.webp";